import React from "react";
import { useLocation } from "react-router-dom";
import NotepadOverview from "./notepad/NotepadOverview";

// The notepad is one view now: a single chronological table of everything saved.
// The four tabs are gone — "My Examples" and "Study Notes" were reading the same
// table from two different screens, and the vocabulary sat behind a third. The
// paths those tabs used still resolve, they just preselect the table's filter.
const StudentNotepad = () => {
  const location = useLocation();
  let initialFilter = "all";
  if (location.pathname.includes("vocabulary")) {
    initialFilter = "vocabulary";
  } else if (
    location.pathname.includes("examples") ||
    location.pathname.includes("notes")
  ) {
    initialFilter = "sentence";
  }

  // the old Dashboard path opens the Progress view
  const initialView = location.pathname.includes("dashboard")
    ? "progress"
    : "notes";

  return (
    <NotepadOverview initialFilter={initialFilter} initialView={initialView} />
  );
};

export default StudentNotepad;
